var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('app-template',[_c('div',{staticClass:"bg-white p-4 rounded shadow"},[_c('chantier-view',{attrs:{"chantier-id":_vm.$route.params.id},on:{"chantier-ended":_vm.handleChantierEnded}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }